import merge from 'lodash/merge';
import type { ContentConfig } from '@ai-content-hub/content-core';
import type { CompositeQuestionTypeDef } from './types';

const registry = new Map<string, CompositeQuestionTypeDef>();

export interface RegisterCompositeQuestionTypeOptions {
    /**
     * When true (default), re-registering the same id merges `defaultConfig` deeply
     * and overlays other fields; preserves `createDefaultData` / `EditComponent` if omitted.
     */
    merge?: boolean;
}

export function registerCompositeQuestionType(
    def: CompositeQuestionTypeDef,
    options?: RegisterCompositeQuestionTypeOptions,
): void {
    const shouldMerge = options?.merge !== false;
    const existing = registry.get(def.id);
    if (existing && shouldMerge) {
        const mergedDefaultConfig =
            def.defaultConfig != null || existing.defaultConfig != null
                ? (merge(
                      {},
                      existing.defaultConfig ?? {},
                      def.defaultConfig ?? {},
                  ) as ContentConfig)
                : undefined;
        registry.set(def.id, {
            ...existing,
            ...def,
            label: def.label ?? existing.label,
            defaultConfig: mergedDefaultConfig,
            createDefaultData: def.createDefaultData ?? existing.createDefaultData,
            EditComponent: def.EditComponent ?? existing.EditComponent,
            mergeConfig: def.mergeConfig ?? existing.mergeConfig,
            editorClassName: def.editorClassName ?? existing.editorClassName,
        });
        return;
    }
    registry.set(def.id, def);
}

export function getCompositeQuestionType(id: string): CompositeQuestionTypeDef | undefined {
    return registry.get(id);
}

export function listCompositeQuestionTypeIds(): string[] {
    return Array.from(registry.keys());
}

export function getAllowedQuestionTypes(ids: string[]): CompositeQuestionTypeDef[] {
    const out: CompositeQuestionTypeDef[] = [];
    for (const id of ids) {
        const def = registry.get(id);
        if (def) {
            out.push(def);
        }
    }
    return out;
}
